import { withApollo } from '@apollo/client/react/hoc'
import { injectIntl } from 'react-intl'
import React, { Component } from 'react'
import { Menu } from 'antd'
import PlaylistBrowserList from './PlaylistBrowserList'
import S from '../Styles'
import _ from 'lodash'

const styles = S.columnBrowser

/**
 * This component will display a tree of playlist to allow the user to navigate
 * in the folder/pool to select a playlist.
 * It will call the onChange function from prop with the _id of the selected playlist.
 * Note that any PlaylistDocument can be selected, including folders and pools.
 */
class PlaylistBrowser extends Component {
	// we must ensure the path in the component starts with 'root'
	// to display the top level playlists
	getInitialSelectedPathFromProp = (selectedPathProp) => {
		if (_.isEmpty(selectedPathProp)) {
			return ['root']
		}

		if (selectedPathProp[0] !== 'root') {
			return ['root', ..._.compact(selectedPathProp)]
		} else {
			return _.compact(selectedPathProp)
		}
	}

	/**
	 * The only property of the state is the path of the currently selected value
	 * For each value if the path we display a PlaylistBrowserList
	 */
	state = {
		path: this.getInitialSelectedPathFromProp(this.props.selectedPath)
	}

	scrollContainerRef = React.createRef()

	onSelectedChange = (path, selectedId, isValid) => {
		if (selectedId) {
			this.props.onChange(isValid ? selectedId : null)
			this.setState({ path: [...path, selectedId] })
		} else {
			// the selected value can be null for example when we select the current playlist
			// of a pool. In this case the last value of the path is the pool id
			this.props.onChange(isValid ? _(path).pull('root').last() : null)
		}
	}

	componentDidUpdate(prevProps, prevState) {
		// When the path change we scroll to the end of the list to show the newly added column
		// We need to use a timeout since we don't know for sure the size if the last rendered column
		// until we have the labels rendered
		if (prevState.path.length < this.state.path.length) {
			setTimeout(() => {
				this.scrollContainerRef.current?.scrollTo({
					left: 20000,
					behavior: 'smooth'
				})
			}, 200)
		}
	}

	render() {
		return (
			<div style={this.props.style}>
				<div style={styles.scroll} ref={this.scrollContainerRef}>
					<div style={styles.container}>
						{this.state.path.map((parentId, index) => {
							/*
								If the selected path is ['root', 'pl1']
								for the first column we need to display the playlists that have no ancestors with pl1 selected
								and for the second column we need to display the playlists that have pl1 as ancestor with no item selected
							*/
							const selected = this.state.path[index + 1] ?? null
							const pathToHere = _.take(
								this.state.path,
								index + 1
							)
							return (
								<PlaylistBrowserList
									key={`playlistbrowserlist-${parentId}`}
									parentId={parentId}
									selected={selected}
									addCurrentPlayListOption={
										this.props.addCurrentPlayListOption
									}
									onSelectedChange={(value) =>
										this.onSelectedChange(
											pathToHere,
											value.selectedId,
											value.isValid
										)
									}
								/>
							)
						})}
					</div>
				</div>
			</div>
		)
	}
}
export default withApollo(injectIntl(PlaylistBrowser))
